module.exports = __webpack_public_path__ + "static/img/jiaolv.ce0d248.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jiaolv.png
// module id = MnxM
// module chunks = 1